import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.info');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import { Router } from '@angular/router'
import { marked } from 'marked';

@Component({
    selector: 'wiz-portal-gsdcadmin-community-info',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.info/view.scss */
/* src/app/portal.gsdcadmin.community.info/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityInfoComponent implements OnInit, OnDestroy {
    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    public community: any = {};
    private destroyed = false;
    public loading = true;
    public loadError = '';
    public loadCode = 0;

    @ViewChild('managerDialog') public managerDialog: ElementRef<HTMLDialogElement>;
    @ViewChild('managerSearch') public managerSearch: ElementRef<HTMLInputElement>;
    public manager: any = null;
    public canAssignManager = false;
    public candidates: any[] = [];
    public candidateText = '';
    public candidatePage = 1;
    public candidateLastPage = 1;
    public candidateTotal = 0;
    public candidatesLoading = false;
    public candidateError = '';
    public assignmentError = '';
    public selectedCandidate: any = null;
    public expectedManagerId = '';
    private candidateRequest = 0;
    private searchTimer: any;
    public groupTotal = 0;
    public hasRepresentative: boolean = true;
    public managerChanging: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.reload();
    }

    public async reload() {
        if (await this.load()) await this.buildEditor();
    }
    public async load() {
        this.loading = true;
        this.loadError = '';
        this.loadCode = 0;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("load", { id: this.community_id }, { timeout: 15000 });
            if (code !== 200) { this.loadCode = code; throw new Error('load'); }
            if (!data?.community) throw new Error('load');
            this.community = data.community;
            this.groupTotal = data.groupTotal;
            this.manager = data.manager || null;
            this.canAssignManager = data.can_assign_manager === true;
            this.hasRepresentative = data.has_representative !== false;
            return true;
        } catch (_) {
            this.loadError = this.loadCode === 403 ? '이 커뮤니티를 조회할 권한이 없습니다.'
                : this.loadCode === 404 ? '커뮤니티를 찾을 수 없습니다.' : '커뮤니티 정보를 불러오지 못했습니다.';
            return false;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async openManagerDialog() {
        if (!this.canAssignManager || this.managerChanging) return;
        this.selectedCandidate = null;
        this.candidateText = '';
        this.assignmentError = '';
        this.expectedManagerId = String(this.community.manager_id || '');
        await this.service.render();
        this.managerDialog.nativeElement.showModal();
        this.managerSearch.nativeElement.focus();
        await this.loadCandidates(1);
    }

    public closeManagerDialog(event?: Event) {
        event?.preventDefault();
        if (this.managerChanging) return;
        clearTimeout(this.searchTimer);
        this.candidateRequest++;
        this.managerDialog?.nativeElement.close();
    }

    public managerBackdrop(event: MouseEvent) {
        const dialog = this.managerDialog?.nativeElement;
        if (!dialog || event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeManagerDialog();
    }

    public async searchCandidates() {
        clearTimeout(this.searchTimer);
        this.candidateRequest++;
        this.candidatesLoading = true;
        this.selectedCandidate = null;
        await this.service.render();
        this.searchTimer = setTimeout(() => this.loadCandidates(1), 250);
    }

    public async loadCandidates(page = 1) {
        if (this.managerChanging) return;
        clearTimeout(this.searchTimer);
        const request = ++this.candidateRequest;
        this.candidatesLoading = true;
        this.candidateError = '';
        this.assignmentError = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('manager_candidates', {
                community_id: this.community_id, page, text: this.candidateText
            }, { timeout: 15000 });
            if (request !== this.candidateRequest || this.destroyed) return;
            if (response?.code !== 200 || !Array.isArray(response.data?.rows)) throw new Error('load');
            const data = response.data;
            this.candidates = data.rows;
            this.candidatePage = data.page;
            this.candidateLastPage = data.lastpage;
            this.candidateTotal = data.total;
            if (this.expectedManagerId !== String(data.manager_id || '')) this.selectedCandidate = null;
            this.expectedManagerId = String(data.manager_id || '');
        } catch (_) {
            if (request !== this.candidateRequest || this.destroyed) return;
            this.candidates = [];
            this.selectedCandidate = null;
            this.candidateError = '목록을 불러오지 못했습니다. 다시 시도해주세요.';
        } finally {
            if (request === this.candidateRequest && !this.destroyed) {
                this.candidatesLoading = false;
                await this.service.render();
            }
        }
    }

    public async selectCandidate(user: any) {
        if (this.managerChanging || this.candidatesLoading || !user.selectable) return;
        this.selectedCandidate = user;
        this.assignmentError = '';
        await this.service.render();
    }

    public async assignManager() {
        if (this.managerChanging || this.candidatesLoading || this.candidateError || !this.selectedCandidate?.selectable) return;
        this.managerChanging = true;
        this.assignmentError = '';
        await this.service.render();
        let response: any;
        try {
            response = await wiz.call('changeManger', {
                user_id: this.selectedCandidate.id, community_id: this.community_id,
                expected_manager_id: this.expectedManagerId
            }, { timeout: 30000 });
        } catch (_) { response = null; }
        if (this.destroyed) return;
        this.managerChanging = false;
        if (response?.code !== 200 || !response.data?.manager) {
            this.assignmentError = response?.data?.message || '처리 결과를 확인하지 못했습니다. 새로 조회 후 다시 시도해주세요.';
            this.selectedCandidate = null;
            await this.service.render();
            return;
        }
        this.manager = response.data.manager;
        this.community.manager_id = this.manager.id;
        this.closeManagerDialog();
        await this.service.render();
        if (response.data.notification_sent === false) {
            await this.service.alert.error('담당자는 변경되었지만 안내 메일을 보내지 못했습니다.');
        } else {
            await this.service.alert.success('서비스 담당자가 지정되었습니다.');
        }
    }

    public async buildEditor() {
        if (this.destroyed || !this.editorElement) return;
        if (this.community.description == null) this.community.description = "";
        const editor = await ClassicEditor.create(this.editorElement.nativeElement, {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            codeBlock: {
                languages: [
                    { language: 'plaintext', label: '평문' },
                    { language: 'c', label: 'C' },
                    { language: 'cpp', label: 'C++' },
                    { language: 'cs', label: 'C#' },
                    { language: 'css', label: 'CSS' },
                    { language: 'diff', label: 'Diff' },
                    { language: 'html', label: 'HTML' },
                    { language: 'java', label: 'Java' },
                    { language: 'javascript', label: 'JavaScript' },
                    { language: 'markdown', label: 'Markdown' }, // 여기서 Markdown 추가
                    { language: 'php', label: 'PHP' },
                    { language: 'python', label: 'Python' },
                    { language: 'ruby', label: 'Ruby' },
                    { language: 'typescript', label: 'TypeScript' },
                    { language: 'xml', label: 'XML' }
                ]
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });
        if (this.destroyed) { await editor.destroy(); return; }
        this.editor = editor;
        this.editor.data.set(this.community.description);
    }

    public async ngOnDestroy() {
        this.destroyed = true;
        clearTimeout(this.searchTimer);
        this.candidateRequest++;
        this.managerDialog?.nativeElement.close();
        if (this.editor) await this.editor.destroy();
    }

    public async update() {
        if (!this.editor) return;
        if (this.tab == 'text') await this.changeTab('editor');
        this.community.description = this.editor.getData();
        const { code } = await wiz.call("update", { id: this.community_id, description: this.community.description });
        if (code != 200) return await this.service.alert.error("오류가 발생했습니다.");
        let res = await this.service.alert.success("저장되었습니다.");
        if (res && !('id' in this.community)) await this.router.navigate(['/admin/community']);
        await this.service.render();
    }

    public tab: 'editor' | 'text' = 'editor';

    public async changeTab(tab: 'editor' | 'text') {
        if (!this.editor) {
            this.tab = tab;
            await this.service.render();
            return;
        }

        if (this.tab === 'editor' && tab === 'text') this.community.description = this.editor.getData();
        if (this.tab === 'text' && tab === 'editor') this.editor.setData(this.community.description || '');

        this.tab = tab;
        await this.service.render();
    }
}

export default PortalGsdcadminCommunityInfoComponent;